import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import google from "../assets/icons/google.png";
import { reviewsData } from "../data/reviews-dummy";


const GoogleReviews = ({ placeId }) => {
  const [reviews, setReviews] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // useEffect(() => {
  //   const fetchReviews = async () => {
  //     try {
  //       const response = await fetch(
  //         `https://api.mytimewatch.com/api/reviews?placeId=${placeId}`
  //       );
  //       const data = await response.json();
  //       // console.log("Fetched Reviews:", data.reviews); // Log fetched reviews
  //       if (response.ok) {
  //         const filteredReviews = data.reviews.filter(
  //           (review) => review.rating >= 4
  //         );
  //         setReviews(filteredReviews);
  //       } else {
  //         setError(data.error || "Failed to fetch reviews");
  //       }
  //     } catch (error) {
  //       console.error(error);
  //       setError("Error fetching data");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  
  //   fetchReviews();
  // }, [placeId]);
  

  // useEffect(() => {
  //   if (reviews.length > 3) {
  //     const interval = setInterval(() => {
  //       setCurrentIndex((prevIndex) => (prevIndex + 3) % reviews.length);
  //     }, 10000);

  //     return () => clearInterval(interval); // Cleanup interval
  //   }
  // }, [reviews]);

  useEffect(()=>{
    setReviews(reviewsData)
    setLoading(false)
  },[])

  if (loading) {
    return <p className="text-center">Loading reviews...</p>;
  }

  if (error) {
    return <p className="text-danger text-center">{error}</p>;
  }
  
  const visibleReviews = reviews
  // const visibleReviews = reviews.slice(
  //   currentIndex,
  //   currentIndex + 3
  // ).concat(
  //   reviews.slice(0, Math.max(0, currentIndex + 3 - reviews.length))
  // );

  return (
    <div className="container my-4">
      {visibleReviews.map((review, index) => (
        <a
          href={`https://www.google.com/maps?ll=28.520151,77.278974&z=14&t=m&hl=en&gl=IN&mapclient=embed&cid=4338795419076303891`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary text-decoration-none"
          key={index}
        >
          <div
            className="shadow-sm mb-md-5 p-3 d-flex align-items-center"
            style={{
              backgroundColor: "#fff",
              maxHeight: "250px",
              overflow: "hidden",
            }}
          >
            <div className="card-body d-flex flex-column justify-content-between">
              <div className="d-flex align-items-center">
                <img
                  src={google}
                  alt="Google Icon"
                  width="30"
                  height="30"
                  className="me-2"
                />
                <div className="text-left">
                  <small className="d-flex justify-content-start card-title text-black mb-0">
                    <strong>{review.author_name}</strong>
                  </small>
                  <small className="d-flex justify-content-start text-muted">
                    {review.relative_time_description}
                  </small>
                </div>
              </div>
              <div className="mt-1 d-flex justify-content-start">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span
                    key={i}
                    className={
                      i < review.rating ? "text-warning" : "text-warning"
                    }
                  >
                    &#9733;
                  </span>
                ))}
              </div>
              <small
                className="card-text text-black mt-2 text-justify mb-0"
                style={{
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 3,
                  overflow: "hidden",
                }}
              >
                {review.text}
              </small>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

export default GoogleReviews;
